import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './solicitacaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista } from './solicitacaoActions';
import { getLista as getListaParceiro } from '../parceiro/parceiroActions';
import { getLista as getListaRacao } from '../racao/racaoActions';
import { getLista as getListaUnidadeMedida } from '../unidadeMedida/unidadeMedidaActions';
import Select from '../common/form/select';

const columns = [{
    field: 'id',
    type: 'int'
}, {
    field: 'status',
    type: 'text'
}, {
    field: 'datahora_solicitacao',
    type: 'date'
}, {
    field: 'data_previsao',
    type: 'date'
}, {
    field: 'nome_parceiro',
    type: 'text'
}, {
    field: 'nome_racao',
    type: 'text'
}, {
    field: 'quantidade',
    type: 'decimal'
}, {
    field: 'sigla_unidade_medida',
    type: 'text'
}];

class Solicitacao extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'data_previsao',
			direction: 'asc' // 'asc' | 'desc'
		},
		ids_status: ['Solicitada', 'Confirmada', 'Sem Status']
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaParceiro();
		this.props.getListaRacao();
		this.props.getListaUnidadeMedida();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.id}
					${item.status}
					${DateFormat.formatarDataSqlParaTela(item.data_previsao)}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}
					${item.nome_parceiro}
					${item.nome_racao}
					${FormatUtils.formatarValorTela(item.quantidade, 2)}
					${item.sigla_unidade_medida}
				`.toUpperCase().includes(pesquisar)
				);
		}).filter(item => {

			if ((this.state.ids_status || []).length && !this.state.ids_status.includes(item.status)) {
				return false;
			}

			return true;

		}).map(item => ({
			...item,
			quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
		}));

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<Select
							name='id_parceiro'
							options={[
								{ id: 'Solicitada', valor: 'Solicitada' },
								{ id: 'Confirmada', valor: 'Confirmada' },
								{ id: 'Produção Agendada', valor: 'Produção Agendada' },
								{ id: 'Em Produção', valor: 'Em Produção' },
								{ id: 'Produção Finalizada', valor: 'Produção Finalizada' },
									{ id: 'Finalizada', valor: 'Finalizada' },
								{ id: 'Sem Status', valor: 'Sem Status' }
							]}
							label='Status *' placeholder='Informe'
							cols='1 1 1 1'
							multiple
							minWidth={450}
							value={this.state.ids_status}
							onChange={values => {
								this.setState({
									ids_status: values.map(item => item.value)
								});
							}} />

						<div style={{ marginTop: 8, width: 270 }}>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ itens: [] });
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Solicitacões'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort	
									field='id'
									label='Número'
									width={10}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort	
									field='status'
									label='Status'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='datahora_solicitacao'
									label='Solicitação'
									width={80}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='data_previsao'
									label='Previsão'
									width={80}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_parceiro'
									label='Parceiro'
									width={300}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_racao'
									label='Ração'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='quantidade'
									label='Quantidade'
									width={80}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='sigla_unidade_medida'
									label='Unidade Medida'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.status}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_previsao)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_parceiro}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_racao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.sigla_unidade_medida}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'warning'}
											width={32}
											small
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Editar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={!item.id_producao}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item,
				datahora_solicitacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao),
				quantidade: parseFloat(item.quantidade)
			}))} name='Solicitacões'>
				{[
					{ componente: <ExcelColumn key={1} label='Número' value='id'/>},
					{ componente: <ExcelColumn key={1} label='Solicitação' value='datahora_solicitacao'/>},
					{ componente: <ExcelColumn key={2} label='Status' value='status'/>},
					{ componente: <ExcelColumn key={3} label='Parceiro' value='nome_parceiro'/>},
					{ componente: <ExcelColumn key={3} label='Ração' value='nome_racao'/>},
					{ componente: <ExcelColumn key={5} label='Quantidade' value='quantidade' type='number'/>},
					{ componente: <ExcelColumn key={6} label='Unidade de Medida' value='sigla_unidade_medida'/>},
					{ componente: <ExcelColumn key={11} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={12} label='Usuário da Alteração' value='nome_usuario_alteracao'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.solicitacao.modoTela,
	aguardando: state.solicitacao.aguardando,
	lista: state.solicitacao.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaParceiro, getListaRacao, getListaUnidadeMedida
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Solicitacao);
